import { RoutePath } from "#utils/route";
import { FlowRecordValueDetailRoute } from "#routes/organization/flows/[flowId]/detail/record/[recordId]/value/[measurementType]";

export const FlowRecordValueSourceRoute = FlowRecordValueDetailRoute.concat(
  new RoutePath({
    path: "/source",
    title: "Add Source",
  })
);
